import { useCallback, useEffect, useState } from 'react';
import {
  useParams,
  useLocation,
  useNavigate,
  generatePath,
} from 'react-router-dom';
import { GeneralLedgerSidepanel } from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import { clearTransactionState } from '../store/slices/gl-transaction';
import {
  useLazyGetCustomerGeneralLedgerTransactionQuery,
  useLazyGetCustomerStatementChangeLogsQuery,
} from '../store/services/customers';

const ProblemGLTransactionHOC = ({
  backPath,
}: {
  backPath: string;
}): React.JSX.Element => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const {
    customersProblemTransactions: { gl },
    customersDictionaries: { currenciesList, baseCurrency, activePermissions },
    administrationDictionaries: { users },
  } = useAppSelector((state) => state);

  const { customerId, transactionId } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();

  const [getCustomerGeneralLedgerTransaction, { isLoading, isFetching }] =
    useLazyGetCustomerGeneralLedgerTransactionQuery();
  const [
    getTransactionChangeLogs,
    { isLoading: changeLogsIsLoading, isFetching: changeLogsIsFetching },
  ] = useLazyGetCustomerStatementChangeLogsQuery();

  const dispatch = useAppDispatch();

  const getTransactionChangeLogsAction = useCallback(
    (cursor?: string) => {
      getTransactionChangeLogs(
        `?take=20&entityType=GENERAL_LEDGER_TRANSACTION&entityId=${transactionId}${
          cursor ? `&cursor=${cursor}` : ''
        }`,
      );
    },
    [transactionId],
  );

  const handleClose = () => {
    setPanelIsOpen(false);

    setTimeout(() => {
      navigate(
        generatePath(`${backPath}${search || ''}`, {
          customerId,
        }),
      );
    }, 100);
  };

  useEffect(() => {
    setPanelIsOpen(true);

    return () => {
      dispatch(clearTransactionState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (customerId && !gl?.transaction && transactionId) {
      getCustomerGeneralLedgerTransaction(transactionId);
    }
  }, [customerId, gl?.transaction, transactionId]);

  return (
    <GeneralLedgerSidepanel
      panelIsOpen={panelIsOpen}
      handleClose={handleClose}
      transaction={gl.transaction}
      isLoading={isLoading || isFetching}
      title="GL Transaction"
      currenciesList={currenciesList}
      baseCurrency={baseCurrency}
      sidepanelExpandedKey="problem-gl"
      activePermission={activePermissions}
      users={users}
      changeLogsIsLoading={changeLogsIsLoading}
      changeLogsIsFetching={changeLogsIsFetching}
      getTransactionChangeLogs={getTransactionChangeLogsAction}
      transactionChangeLogsPagination={gl.transactionChangeLogsPagination}
      changeLogs={gl.transactionChangeLogs}
    />
  );
};

export default ProblemGLTransactionHOC;
